import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { RECENT_SEARCH_HEIGHT_IN_PX, RECENT_SEARCH_WIDTH_IN_PX } from '@atlaskit/editor-common/ui';
import { hideLinkingToolbar, setUrlToMedia, unlink } from '../commands/linking';
import { getMediaLinkingState } from '../pm-plugins/linking';
import MediaLinkingToolbar from '../ui/MediaLinkingToolbar';
var FORCE_FOCUS_SELECTOR = '[data-testid="add-link-button"],[data-testid="edit-link-button"]';
export function shouldShowMediaLinkToolbar(editorState) {
  var mediaLinkingState = getMediaLinkingState(editorState);
  if (!mediaLinkingState || mediaLinkingState.mediaPos === null) {
    return false;
  }
  var _editorState$schema = editorState.schema,
    _editorState$schema$n = _editorState$schema.nodes,
    media = _editorState$schema$n.media,
    mediaInline = _editorState$schema$n.mediaInline,
    link = _editorState$schema.marks.link;
  var node = editorState.doc.nodeAt(mediaLinkingState.mediaPos);
  if (!node || ![media, mediaInline].includes(node.type)) {
    return false;
  }
  var _editorState$doc$reso = editorState.doc.resolve(mediaLinkingState.mediaPos),
    parent = _editorState$doc$reso.parent;
  return parent && parent.type.allowsMarkType(link);
}
export var getLinkingToolbar = function getLinkingToolbar(toolbarBaseConfig, mediaLinkingState, state, intl, pluginInjectionApi, providerFactory) {
  var link = mediaLinkingState.link,
    visible = mediaLinkingState.visible,
    editing = mediaLinkingState.editable,
    mediaPos = mediaLinkingState.mediaPos;
  if (visible && mediaPos !== null) {
    var node = state.doc.nodeAt(mediaPos);
    if (node) {
      return _objectSpread(_objectSpread({}, toolbarBaseConfig), {}, {
        height: RECENT_SEARCH_HEIGHT_IN_PX,
        width: RECENT_SEARCH_WIDTH_IN_PX,
        forcePlacement: true,
        items: [{
          type: 'custom',
          fallback: [],
          disableArrowNavigation: true,
          render: function render(view, idx) {
            if (!view || !providerFactory) {
              return null;
            }
            return /*#__PURE__*/React.createElement(MediaLinkingToolbar, {
              key: idx,
              displayUrl: link,
              providerFactory: providerFactory,
              intl: intl,
              editing: editing,
              onUnlink: function onUnlink() {
                var _pluginInjectionApi$a;
                return unlink(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions)(view.state, view.dispatch, view);
              },
              onBack: function onBack(href, meta) {
                if (href.trim() && meta.inputMethod) {
                  var _pluginInjectionApi$a2;
                  setUrlToMedia(href, meta.inputMethod, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a2 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a2 === void 0 ? void 0 : _pluginInjectionApi$a2.actions)(view.state, view.dispatch, view);
                }
                hideLinkingToolbar(view.state, view.dispatch, view);
              },
              onCancel: function onCancel() {
                var _pluginInjectionApi$f;
                hideLinkingToolbar(view.state, view.dispatch, view, true);
                /** Focus should move to the 'Add link' button when the toolbar closes
                 * and not close the floating toolbar.
                 */
                var tr = view.state.tr,
                  dispatch = view.dispatch;
                pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$f = pluginInjectionApi.floatingToolbar) === null || _pluginInjectionApi$f === void 0 || (_pluginInjectionApi$f = _pluginInjectionApi$f.actions) === null || _pluginInjectionApi$f === void 0 || _pluginInjectionApi$f.forceFocusSelector(FORCE_FOCUS_SELECTOR)(tr);
                dispatch(tr);
              },
              onSubmit: function onSubmit(href, meta) {
                var _pluginInjectionApi$a3;
                setUrlToMedia(href, meta.inputMethod, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a3 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a3 === void 0 ? void 0 : _pluginInjectionApi$a3.actions)(view.state, view.dispatch, view);
                hideLinkingToolbar(view.state, view.dispatch, view);
              },
              onBlur: function onBlur() {
                hideLinkingToolbar(view.state, view.dispatch, view);
              }
            });
          }
        }]
      });
    }
  }
};